import { useShedConfig } from "../../contexts/ShedConfigContext";
import Section from "../layout/Section";

export default function ShedConfigurationSection() {
  const { openDrawer } = useShedConfig();

  return (
    <Section title="Shed Configuration and Installation">
      <div className="mt-2 mb-2 p-4 rounded text-center">
        <p className="text-sm mx-4 md:mx-36">
          Click Add information to open the side panel. From there you can enter
          the shed dimensions (width, length, height), as well as customized
          options like doors, windows and ventilation. This information is
          essential to generate the final technical plan and comply with county
          or HOA approval requirements.
        </p>
      </div>
      <button
        onClick={openDrawer}
        className="bg-[#2f5241] hover:bg-[#2f5241e1] text-white px-5 py-2 rounded mt-2 hover:cursor-pointer"
      >
        Add information
      </button>
    </Section>
  );
}
